
import React, { useEffect, useState } from "react";

import { Tab, Tabs } from "@mui/material";

import { jwtDecode } from "jwt-decode";
import LayoutBackOffice from "../../../components/LayoutBackOffice";
import Categories from "./categorie/Categories";
import SubCategorie from "./subCategorie/SubCategorie";
import Poster from "./poster/Posters"
import Specification from "./specification/Specification";
import Marques from "./marque/Marques";

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`
  };
}

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

const Parametrages = () => {
  const [valueTab, setValueTab] = useState(0);
  const [connectedUser, setConnectedUser] = useState(null);

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };



  return (
    <LayoutBackOffice>
      <div className="w-full h-full p-2">
        <div className="w-full ">
          <h1 className="text-2xl md:text-3xl font-extrabold">Paramètres</h1>
          <p className="mt-2 text-gray-500 font-medium text-sm sm:text-base md:text-lg">
            Paramétrer les éléments nécessaires au fonctionnement de
            l’application
          </p>
        </div>

        <div className="my-5 border-b">
          <Tabs
            value={valueTab}
            onChange={handleChangeTab}
            variant="scrollable"
            textColor="black"
            scrollButtons="auto"
            aria-label="basic tabs example"
          >
            <Tab
              label="Categories"
              {...a11yProps(0)}
              sx={{
                textTransform: "capitalize",
                fontSize: 14,
                fontWeight: 700
              }}
            />
            {/* <Tab
              label="SubCategorie"
              {...a11yProps(1)}
              sx={{
                textTransform: "capitalize",
                fontSize: 14,
                fontWeight: 700
              }}
            /> */}
            <Tab
              label="Spécification"
              {...a11yProps(1)}
              sx={{
                textTransform: "capitalize",
                fontSize: 14,
                fontWeight: 700
              }}
            />
            <Tab
              label="Marque"
              {...a11yProps(2)}
              sx={{
                textTransform: "capitalize",
                fontSize: 14,
                fontWeight: 700
              }}
              
            />
            <Tab
              label="Affiches"
              {...a11yProps(3)}
              sx={{
                textTransform: "capitalize",
                fontSize: 14,
                fontWeight: 700
              }}
            />
          </Tabs>
        </div>

        <CustomTabPanel value={valueTab} index={0}>
          <Categories />
        </CustomTabPanel>
        {/* <CustomTabPanel value={valueTab} index={1}>
          <SubCategorie />
        </CustomTabPanel> */}
        <CustomTabPanel value={valueTab} index={1}>
          <Specification />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={2}>
          <Marques />
        </CustomTabPanel>
        <CustomTabPanel value={valueTab} index={3}>
          <Poster />
        </CustomTabPanel>
      </div>
    </LayoutBackOffice>
  );
};

export default Parametrages;
